import InterfaceLogin from "../apiInterface/InterfaceLogin";

class DataLogin {
  async getDataLogin(username, pass) {
    let dt: any;
    await InterfaceLogin.postLogin(username, pass)
      .then(response => {
        dt = response;
        // console.log('aa', dt)
      })
      .catch(e => {
        // console.log(e.response);
        dt = e.response;
        // console.log('bb', dt)
      });
    return dt;
  }
  // async getDataLogin(username, pass): Promise<TODO> {
  //   let dt: any
  //   await InterfaceLogin.postLogin(username, pass).then((response) => {
  //     dt = response
  //     // console.log(dt)
  //   })
  //     .catch((e) => {
  //       console.log(e.response);
  //     });
  //   return dt
  // }
}

export default new DataLogin();
